module.exports = __webpack_public_path__ + "static/media/dhoka.597ec18d.ogg";